import { useEffect, useState } from 'react';
import { quickNav, siteInfo } from '@/mocks/siteInfo';

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'bg-background-50/95 shadow-[0_1px_0_0_oklch(var(--background-200))] backdrop-blur'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-4 py-3 md:px-8 md:py-4" aria-label="站内导航">
        <a
          href="#top"
          className={`flex items-center gap-2 whitespace-nowrap font-heading text-lg font-bold transition-colors ${
            scrolled || open ? 'text-foreground-950' : 'text-background-50'
          }`}
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-sm text-background-50">
            会
          </span>
          {siteInfo.name}
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {quickNav.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className={`block whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  scrolled
                    ? 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                    : 'text-background-100 hover:bg-background-50/15 hover:text-background-50'
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-label="展开导航菜单"
          className={`flex h-9 w-9 items-center justify-center rounded-md md:hidden ${
            scrolled || open ? 'text-foreground-950' : 'text-background-50'
          }`}
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </nav>

      {open ? (
        <ul className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {quickNav.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="block rounded-md px-3 py-3 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      ) : null}
    </header>
  );
}